import { render, staticRenderFns } from "./PresentationImg.vue?vue&type=template&id=358a3f86&"
import script from "./PresentationImg.vue?vue&type=script&lang=js&"
export * from "./PresentationImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports